// Rate-limited wrapper around the platform-level dock bounce command.
//
// Only fires on Tauri-macOS (the platform implements `bounceDock`); web and
// other OSs silently no-op via optional chaining.
//
// Skipped when the window is already focused (the OS would swallow the
// request anyway on macOS) and rate-limited to one bounce every
// BOUNCE_INTERVAL_MS to prevent spam when several events fire in sequence.

import type { Platform } from "@/context/platform"

const BOUNCE_INTERVAL_MS = 5000

let lastBounce = 0

function isWindowFocused(): boolean {
  if (typeof document === "undefined") return true
  return !document.hidden && document.hasFocus?.() !== false
}

export function bounceDock(platform: Platform): void {
  if (!platform.bounceDock) return
  if (isWindowFocused()) return

  const now = Date.now()
  if (now - lastBounce < BOUNCE_INTERVAL_MS) return
  lastBounce = now

  void Promise.resolve(platform.bounceDock()).catch(() => undefined)
}
